import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
  let { isAuth, loading, isBlocked } = useContext(AuthContext);

  if (loading) {
    return <BackdropLoading />;
  }

  if (isBlocked) isAuth = false;
  if (!isAuth && isPrivate) {
    return <Redirect to={{ pathname: "/login", state: { from: rest.location } }} />;
  }

  if (isAuth && !isPrivate) {
    return <Redirect to={{ pathname: "/", state: { from: rest.location } }} />;
  }

  return <RouterRoute {...rest} component={Component} />;
};

export default Route;
